<template>
  <v-data-table :headers="headers" :items="remesasPersonal" class="transparent" hide-default-footer disable-pagination>
    <template v-slot:[`item.fk_idRemesa`]="{ item }">
      {{ item.fk_idRemesa }}
    </template>
    <template v-slot:[`item.fecha`]="{ item }">
      {{ humanizeDate(item.fecha) }}
    </template>
  </v-data-table>
</template>

<script>
import DateAdapter from '@src/utils/DateAdapter'

export default {
  props: {
    remesasPersonal: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  data() {
    return {
      headers: [
        { text: 'ID Remesa', value: 'fk_idRemesa', width: '20%', align: 'right' },
        { text: 'Fecha de asignación', value: 'fecha', width: '80%' },
      ],
    }
  },

  methods: {
    humanizeDate(date) {
      if (date) {
        return new DateAdapter(date, 'YYYY-MM-DDTHH:mm:ss').toHumanReadable()
      }

      return '-'
    },
  },
}
</script>
